import { Injectable } from '@angular/core';
import { NavController } from '@ionic/angular';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { AuthService } from '../app/auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AutoLoginGuard {
  constructor(private authService: AuthService, private navController: NavController) {
    // console.log('[AutoLoginGuard] constructor()');
  }

  canLoad(): Observable<boolean> {
    return this.authService.isAuthenticated.pipe(
      filter(val => val !== null), // Filter out initial Behaviour subject value
      take(1), // Otherwise the Observable doesn't complete!
      map(isAuthenticated => {
        if (isAuthenticated) {
          // Directly open inside area
          this.navController.navigateRoot('/dashboard');
        } else {
          // Simply allow access to the login
          return true;
        }
      })
    );
  }
}
